import { render, staticRenderFns } from "./yqglxq.vue?vue&type=template&id=4c73a1fe&scoped=true&"
import script from "./yqglxq.vue?vue&type=script&lang=js&"
export * from "./yqglxq.vue?vue&type=script&lang=js&"
import style0 from "./yqglxq.vue?vue&type=style&index=0&id=4c73a1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73a1fe",
  null
  
)

export default component.exports